// extracted by mini-css-extract-plugin
export default {"table":"PricingSettings_table__GoX6U"};